import { defineComponent as _defineComponent } from 'vue'
import DomService from '@/core/dom.service';
import useBreakpoints from '@/core/responsive/breakpoints/breakpoint.mixin';
import { store } from '@/store';
import { computed, ref, watch} from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Flyover',
  props: {
    openState: { type: Boolean },
    contentClasses: null,
    noScrollEvent: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({(e: 'close'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    openState?: boolean,
    contentClasses?: any,
    noScrollEvent?: boolean
}

const showAuthTopBar = computed<boolean>(() => store.getters['app/showAuthTopBar']);
const usp = computed<IUsp>(() => store.getters['app/usp']);





const modalIsOpen = ref<boolean>(false);
const showModal = ref<boolean>(false);
const modalReferences = ref<HTMLElement>();
const delayShowMs = 10;

// Align with maximum animation time for modal classes in <style> below
const closeAnimationTimeMsMobile = 801;
const closeAnimationTimeMsDesktop = 501;

const breakpointIsActive = useBreakpoints();
const isLargeBreakpoint = computed<boolean>(() => {
    return breakpointIsActive.value.large;
});

const keyListener = (e) => {
    if (e.key === 'Escape') {
        emit('close');
    }
};

watch(() => props.openState, onOpenStateChanged);

function onOpenStateChanged() {
    if (props.openState) {
        window.addEventListener('keydown', keyListener);

        if (document.querySelector('[data-content-scroll-container]')) { // TODO , refactor and move to DomService
            const scrollbarWidth = window.outerWidth - window.innerWidth;
            if (scrollbarWidth) {
                document.querySelector('[data-content-scroll-container]').setAttribute('style', `padding-right: ${scrollbarWidth}px`);
            }
        }

        onModalOpen();
    } else {
        window.removeEventListener('keydown', keyListener);
        if (document.querySelector('[data-content-scroll-container]')) {
            document.querySelector('[data-content-scroll-container]').setAttribute('style', 'padding-right: 0px;');
        }

        onModalClose();
    }
}

function onModalOpen(): void {
    if (!props.noScrollEvent) {
        DomService.addElementClass('html', 'modal-open');
    }
    modalIsOpen.value = true;
    setTimeout(() => {
        showModal.value = true;

        requestAnimationFrame(() => {
            focusFirstInteractiveElement();
        });

    }, delayShowMs);
}

function focusFirstInteractiveElement(): void {
    if (!modalReferences) return;
    const modalEl = modalReferences.value;
    if (!modalEl) return;

    const selectors = [
        'input:not([disabled]):not([type="hidden"])',
        'select:not([disabled])',
        'textarea:not([disabled])',
        'button:not([disabled])',
        'a[href]',
        '[tabindex]:not([tabindex="-1"])'
    ];

    const firstFocusable = modalEl.querySelector<HTMLElement>(selectors.join(','));
    if (firstFocusable && firstFocusable.offsetParent !== null) {
        firstFocusable.focus();
    } else {
        setTimeout(() => focusFirstInteractiveElement(), 100); // Retry shortly
    }

}

function onModalClose(): void {
    if (!props.noScrollEvent) {
        DomService.removeElementClass('html', 'modal-open');
    }
    showModal.value = false;
    setTimeout(() => {
        modalIsOpen.value = props.openState;
    }, breakpointIsActive.value.large ? closeAnimationTimeMsDesktop : closeAnimationTimeMsMobile);
}

function closeFlyover() {
    emit('close');
}


return { __sfc: true,showAuthTopBar, usp, props, emit, modalIsOpen, showModal, modalReferences, delayShowMs, closeAnimationTimeMsMobile, closeAnimationTimeMsDesktop, breakpointIsActive, isLargeBreakpoint, keyListener, onOpenStateChanged, onModalOpen, focusFirstInteractiveElement, onModalClose, closeFlyover }
}

})